import { MenuItem, MenuItems } from '../models/menu-items';
import * as auth from '../../auth/actions/auth.actions'
import * as menus from '../actions/menus.actions';
import { Entities, generateEntities, parseEntities } from '../../core/helpers/entities';
import { RequestWrap } from '../../core/models/request-wrap';
import { parseChain } from '../../core/helpers/utility';
import { getNewTtl } from '../../core/helpers/date'

export interface State {
  error: any
  items: MenuItems
  activeMenuChain: string[]
  activeMenuId: string | null
  loading: boolean
  loaded: boolean,
  menusTtl: Date
  megaMenuOpen: boolean
}

const initialState: State = {
  error: null,
  items: {},
  activeMenuChain: [],
  activeMenuId: null,
  loading: false,
  loaded: false,
  menusTtl: null,
  megaMenuOpen: false
}

export function reducer(
  state = initialState,
  action: menus.Actions | auth.Actions
) {
  let wrap: RequestWrap<MenuItem[]>
  let generatedData: Entities<MenuItem>

  switch (action.type) {
    case menus.GET:
      return {
        ...state,
        loading: true,
        loaded: false
      }

    case menus.GET_SUCCESS:
      wrap = action.payload
      generatedData = generateEntities(wrap, 'code')
      return {
        ...state,
        items: generatedData.entities,
        loaded: true,
        loading: false,
        menusTtl: getNewTtl()
      }

    case menus.GET_FAILED:
      return {
        ...state,
        error: action.payload,
        loaded: false,
        loading: false
      }

    case menus.NAVIGATE:
      return {
        ...state,
        activeMenuChain: parseChain(parseEntities(state.items), action.payload),
        activeMenuId: action.payload
      }

    case menus.TOGGLE_MEGA_MENU:
      return {
        ...state,
        megaMenuOpen: action.payload
      }

    case auth.LOGOUT:
      return initialState

    default:
      return state
  }
}

export const isLoading = (state: State) => state.loading
export const getMenuEntities = (state: State) => state && state.items
export const getActiveMenuItemId = (state: State) => state.activeMenuId
export const getActiveMenuChain = (state: State) => state.activeMenuChain
export const getError = (state: State) => state.error
export const isMenusTtlExpired = (state: State) => state.menusTtl === null || state.menusTtl < new Date()
export const isMegaMenuOpen = (state: State) => state.megaMenuOpen
